// extracted by mini-css-extract-plugin
export default {"nav":"pAmIZO","menuToggle":"YRyQqb","toggleOpen":"oX7wPA","buttonContainer":"KbTtfL","toggleButton":"enVN3p"};